<div
    checkoutCy="reported_ticket_popover"
    data-tc-action="Clic_affichage"
    data-tc-clic="Info-bulle_explicative"
    attr.data-tc-categorie="{{ dataTcCategory }}"
    class="popover is-popover-bottom"
>
    <span class="icon is-smaller">
        <i class="tri-infos-circle"></i>
    </span>
    <div class="popover-content line-height-normal">
        {{ popover }}
    </div>
</div>
